import React from 'react';
import { Link } from 'react-router-dom';
import { CheckCircle, MapPin, Heart, Phone } from 'lucide-react';
import { Button } from '../components/ui/button';
import { aboutInfo } from '../mock';
import IconListCard from '../components/sections/IconListCard';
import ValueCard from '../components/sections/ValueCard';
import PageMeta from '../components/sections/PageMeta';

const CORE_VALUES = [
  {
    icon: Heart,
    title: 'Compassion',
    description: 'We treat every client with kindness, empathy, and genuine care',
  },
  {
    icon: CheckCircle,
    title: 'Professionalism',
    description: 'Licensed nurses with extensive experience and clinical expertise',
  },
  {
    icon: Heart,
    title: 'Advocacy',
    description: 'We speak up for our clients and ensure their voices are heard',
  },
];

const About = () => (
  <div className="min-h-screen">
    <PageMeta
      title="About Nurse Gerri | Bring-A-Nurse Senior Companion, Fuquay Varina NC"
      description="Meet Nurse Gerri — a licensed Registered Nurse dedicated to compassionate, professional nurse companion care for seniors and their families in Fuquay Varina, Holly Springs, Apex, and Cary, NC."
      path="/about"
    />
    <section className="bg-gradient-to-br from-blue-50 to-white py-16 px-4 sm:px-6 lg:px-8 pb-0">
      <div className="max-w-7xl mx-auto text-center">
        <h1 className="text-4xl sm:text-5xl font-bold text-gray-900 mb-6">
          About Bring-A-Nurse Senior Companion
        </h1>
        <p className="text-xl text-gray-600 max-w-3xl mx-auto mb-8">
          Dedicated to providing compassionate, professional nursing support for seniors and their families
        </p>
      </div>
    </section>

    <section className="bg-gradient-to-br from-blue-50 to-white px-4 sm:px-6 lg:px-8 pb-20">
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-start">
          <div className="rounded-2xl overflow-hidden shadow-xl">
            <img
              src="https://customer-assets.emergentagent.com/job_0aa6ae46-54a3-49aa-8f4a-e031b08b33ae/artifacts/e3e7suo1_image.png"
              alt="Nurse Gerri providing compassionate care"
              className="w-full h-full object-cover"
            />
          </div>

          <div className="space-y-6">
            <h2 className="text-3xl sm:text-4xl font-bold text-gray-900">
              {aboutInfo.title}
            </h2>
            {aboutInfo.description.split('\n\n').map((paragraph) => (
              <p key={paragraph.slice(0, 60)} className="text-lg text-gray-600 leading-relaxed">
                {paragraph}
              </p>
            ))}
            <div className="pt-4">
              <Link to="/contact">
                <Button size="lg" className="bg-coral-500 hover:bg-coral-600 text-white">
                  <Phone className="w-5 h-5 mr-2" />
                  Book Your Consultation
                </Button>
              </Link>
            </div>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mt-20">
          <IconListCard
            icon={Heart}
            title="Our Qualifications"
            items={aboutInfo.qualifications}
          />
          <IconListCard
            icon={MapPin}
            title="Service Areas"
            intro="Proudly serving the following areas in North Carolina:"
            items={aboutInfo.serviceAreas}
            footer={aboutInfo.serviceAreaNote}
          />
        </div>
      </div>
    </section>

    <section className="py-20 px-4 sm:px-6 lg:px-8 bg-blue-50">
      <div className="max-w-7xl mx-auto">
        <h2 className="text-3xl sm:text-4xl font-bold text-gray-900 text-center mb-12">
          Our Core Values
        </h2>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {CORE_VALUES.map((value) => (
            <ValueCard
              key={value.title}
              icon={value.icon}
              title={value.title}
              description={value.description}
            />
          ))}
        </div>
      </div>
    </section>
  </div>
);

export default About;
